export default class ParsingError extends Error {}

export function toParsingError(error: Error): ParsingError {
  if (error instanceof ParsingError) {
    return error;
  }
  return new ParsingError(error.message);
}
